import React from "react";
import useFetch from "../../hooks/useFetch";
import "./featured.css";

import londonImg from "../../assets/london.jpg";
import berlineImg from "../../assets/berline.jpg";
import parisImg from "../../assets/paris.jpg";

const Featured = () => {
  // المدن التي نريد عرضها مع الصور الخاصة
  const cities = [
    { name: "berline", img: berlineImg },
    { name: "paris", img: parisImg },
    { name: "london", img: londonImg },
  ];

  // استدعاء API لإرجاع عدد الخصائص لكل مدينة
  const { data, loading, error } = useFetch(
    `/hotels/countByCity?cities=${cities.map(c => c.name).join(",")}`
  );

  return (
    <div className="featured">
      {loading ? (
        "Loading please wait..."
      ) : (
        data &&
        cities.map((city, index) => (
          <div className="featuredItem" key={city.name}>
            <img src={city.img} alt={city.name} className="featuredImg" />
            <div className="featuredTitles">
              <h1>{city.name.charAt(0).toUpperCase() + city.name.slice(1)}</h1>
              <h2>{data[index]} properties</h2>
            </div>
          </div>
        ))
      )}
      {error && <p>{error}</p>}
    </div>
  );
};

export default Featured;



